module.exports = __webpack_public_path__ + "static/media/snippet_banned_f.435d8660.png";